import { IS_PRIVATE } from '@/common/const/env'

const origin = window.location.origin

export const KUSBSAFEIDTOOL = IS_PRIVATE ?
  `${origin}/tool/kusbsafeidtool.exe` :
  '//cd001.www.duba.net/duba/install/packages/dubateam/kusbsafeidtool.exe'

export const REMOTEASSISTSETUP = IS_PRIVATE ?
  `${origin}/tool/remoteassistsetup.msi` :
  '//cd001.www.duba.net/duba/install/packages/dubateam/remoteassistsetup.msi'

/** 企点在线客服（控制台「立即接通」、AI 助手咨询购买 / 咨询续订） */
export const QIDIAN_ONLINE_SERVICE_URL = 'https://wpa1.qq.com/GJdE2EJ8?_type=wpa&qidian=true'

export function openQidianOnlineService () {
  window.open(QIDIAN_ONLINE_SERVICE_URL)
}
